import React from "react";
import { Navigate } from "react-router-dom";
import { getSecureLocalItem, removeSecureLocalItem } from "utils/secureSessionStorage";

const AuthRoute = ({ children }) => {
  const token = getSecureLocalItem("token");
  const role = getSecureLocalItem("role");

  if (token) {
    if (role === "SUPER_ADMIN") {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (role === "Company" || role === "Employee") {
      return <Navigate to="/company/dashboard" replace />;
    } else {
      // Invalid or missing role, clear invalid session
      removeSecureLocalItem("token");
      removeSecureLocalItem("role");
      removeSecureLocalItem("user");
      return children;
    }
  }

  return children;
};

export default AuthRoute;
